import { render, staticRenderFns } from "./v-button-dropdown.vue?vue&type=template&id=59fffb9a&"
import script from "./v-button-dropdown.vue?vue&type=script&lang=js&"
export * from "./v-button-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./v-button-dropdown.vue?vue&type=style&index=0&id=59fffb9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports